import React, { createContext, useContext, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [ isLoggedIn, setIsLoggedIn ] =  useState(false)  
  const [ view, setView] = useState('');
  const [ room, setRoom] = useState({});
  const [  appData, setAppData ]  = useState(false);
  const [ OM_user, setOM_user] = useState({});
  const [ TC_user, setTC_user] = useState({});
  const [ user, setUser] = useState({});
  const [ meetings, setMeetings] = useState([]);
  const [ currentMeeting, setCurrentMeeting] = useState({});
  const [ events, setEvents ] = useState({});
  const [ currentEvent, setCurrentEvent ] = useState({});
  const [ currentVote, setCurrentVote ] = useState({});


  const [ notifications, setNotifications] = useState([]);
  const [ isLoading, setIsLoading ] = useState(false)
  
  // const history = useHistory();

  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  //   setUser(userInfo);
  //   if (!userInfo) history.push("/");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [history]);

    const updateAppData = (newData) => {
    setAppData((prevState) => ({
isLoggedIn, 
       
view, 
room,
user,
OM_user, 
TC_user, 
meetings,
currentMeeting, 
events,
currentEvent,
 currentVote, 
notifications,
isLoading,
...prevState,
...newData,  
 
      
     
       

        
   }));
        
        
        
    
  };
  return (
    <AppContext.Provider
      value={{
        appData, 
        updateAppData,
        isLoggedIn, 
        setIsLoggedIn,
        view, 
        setView,
        room,
        setRoom,
        user,
        setUser,
        OM_user, 
        setOM_user,
        TC_user, 
        setTC_user,
        meetings,
        setMeetings,
        currentMeeting, 
        setCurrentMeeting,
        events,
        setEvents,
        currentEvent,
        setCurrentEvent,
        notifications,
        setNotifications,
        currentVote, 
        setCurrentVote,
        isLoading,
        setIsLoading,
      }}
  
    >
      {children}
    </AppContext.Provider>
  );
};

export const AppState = () => {
  return useContext(AppContext);
};

export default AppProvider;